import {Bento, Image, Text} from '@primer/react-brand'
import {useState} from 'react'

enum VideoState {
  Started,
  NotStarted,
}

const styles = {
  overlayWrapper: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
  },
  overlayHeading: {
    textAlign: 'center' as const,
  },
  playButton: {
    background: 'none',
    border: 'none',
    marginTop: '20px',
  },
  videoFrame: {
    width: '100%',
    height: '100%',
    border: '0',
  },
}

export function ExperimentalVideo() {
  const [videoState, setVideoState] = useState<VideoState>(VideoState.NotStarted)
  const hideOverlay = videoState === VideoState.Started

  return (
    <Bento.Item columnSpan={12} rowSpan={{xsmall: 3, medium: 6}} visualAsBackground>
      <Bento.Content hidden={hideOverlay} style={styles.overlayWrapper}>
        <Bento.Heading weight="semibold" style={styles.overlayHeading} size={'3'} as="h3">
          What is GitHub Copilot?
        </Bento.Heading>
        <Text style={{zIndex: '1'}}>
          <button onClick={() => setVideoState(VideoState.Started)} style={styles.playButton}>
            <svg
              role="button"
              aria-label="Play video"
              width="61"
              height="61"
              viewBox="0 0 61 61"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="60.8" height="60.8" rx="30.4" fill="white" />
              <path
                d="M40.1716 28.5196C41.6192 29.3554 41.6192 31.4449 40.1716 32.2807L27.143 39.8027C25.6954 40.6385 23.8859 39.5938 23.8859 37.9222L23.8859 22.8781C23.8859 21.2065 25.6954 20.1618 27.143 20.9976L40.1716 28.5196Z"
                fill="black"
              />
            </svg>
          </button>
        </Text>
      </Bento.Content>
      <Bento.Visual style={{padding: 0}}>{hideOverlay ? <Video /> : <Overlay />}</Bento.Visual>
    </Bento.Item>
  )
}

function Video() {
  return (
    <iframe
      src="https://www.youtube-nocookie.com/embed/Z7hp241--vc?si=66DKDWNxWwlKi3A2&amp;autoplay=1"
      title="What is GitHub Copilot?"
      style={styles.videoFrame}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    />
  )
}

function Overlay() {
  return (
    <Image
      src="/images/modules/site/copilot/enterprise-6.webp"
      alt="What is GitHub Copilot?"
      width="100%"
      loading="lazy"
    />
  )
}

try{ ExperimentalVideo.displayName ||= 'ExperimentalVideo' } catch {}
try{ Video.displayName ||= 'Video' } catch {}
try{ Overlay.displayName ||= 'Overlay' } catch {}